import _asyncToGenerator from "/codebuild/output/src3701839561/src/proteket-gatsby/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "/codebuild/output/src3701839561/src/proteket-gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/codebuild/output/src3701839561/src/proteket-gatsby/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _regeneratorRuntime from "/codebuild/output/src3701839561/src/proteket-gatsby/node_modules/@babel/runtime/regenerator/index.js";
import { Hub } from '@aws-amplify/core';
import { isBrowser, assertTokenProviderConfig, isTokenExpired, AMPLIFY_SYMBOL } from '@aws-amplify/core/internals/utils';
import { assertServiceError } from '../../../errors/utils/assertServiceError.mjs';
import { AuthError } from '../../../errors/AuthError.mjs';
import { oAuthStore } from '../utils/oauth/oAuthStore.mjs';
import { addInflightPromise } from '../utils/oauth/inflightPromise.mjs'; // Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var TokenOrchestrator = /*#__PURE__*/function () {
  function TokenOrchestrator() {
    var _this = this;

    _classCallCheck(this, TokenOrchestrator);

    this.waitForInflightOAuth = isBrowser() ? /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return oAuthStore.loadOAuthInFlight();

            case 2:
              if (_context.sent) {
                _context.next = 4;
                break;
              }

              return _context.abrupt("return");

            case 4:
              if (!_this.inflightPromise) {
                _context.next = 6;
                break;
              }

              return _context.abrupt("return", _this.inflightPromise);

            case 6:
              // when there is valid oauth config and there is an inflight oauth flow, try
              // to block async calls that require fetching tokens before the oauth flow completes
              // e.g. getCurrentUser, fetchAuthSession etc.
              _this.inflightPromise = new Promise(function (resolve, _reject) {
                addInflightPromise(resolve);
              });
              return _context.abrupt("return", _this.inflightPromise);

            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })) : /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));
  }

  _createClass(TokenOrchestrator, [{
    key: "setAuthConfig",
    value: function setAuthConfig(authConfig) {
      oAuthStore.setAuthConfig(authConfig.Cognito);
      this.authConfig = authConfig;
    }
  }, {
    key: "setTokenRefresher",
    value: function setTokenRefresher(tokenRefresher) {
      this.tokenRefresher = tokenRefresher;
    }
  }, {
    key: "setAuthTokenStore",
    value: function setAuthTokenStore(tokenStore) {
      this.tokenStore = tokenStore;
    }
  }, {
    key: "getTokenStore",
    value: function getTokenStore() {
      if (!this.tokenStore) {
        throw new AuthError({
          name: 'EmptyTokenStoreException',
          message: 'TokenStore not set'
        });
      }

      return this.tokenStore;
    }
  }, {
    key: "getTokenRefresher",
    value: function getTokenRefresher() {
      if (!this.tokenRefresher) {
        throw new AuthError({
          name: 'EmptyTokenRefresherException',
          message: 'TokenRefresher not set'
        });
      }

      return this.tokenRefresher;
    }
  }, {
    key: "getTokens",
    value: function () {
      var _getTokens = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(options) {
        var _tokens, _tokens$idToken$paylo, _tokens$idToken, _tokens$idToken$paylo2, _tokens$clockDrift, _tokens$accessToken$p, _tokens$accessToken, _tokens$accessToken$p2, _tokens$clockDrift2, _tokens2, _tokens3, _tokens4;

        var tokens, _this$authConfig, username, idTokenExpired, accessTokenExpired;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                assertTokenProviderConfig((_this$authConfig = this.authConfig) === null || _this$authConfig === void 0 ? void 0 : _this$authConfig.Cognito);
                _context3.next = 7;
                break;

              case 4:
                _context3.prev = 4;
                _context3.t0 = _context3["catch"](0);
                return _context3.abrupt("return", null);

              case 7:
                _context3.next = 9;
                return this.waitForInflightOAuth();

              case 9:
                this.inflightPromise = undefined;
                _context3.next = 12;
                return this.getTokenStore().loadTokens();

              case 12:
                tokens = _context3.sent;
                _context3.next = 15;
                return this.getTokenStore().getLastAuthUser();

              case 15:
                username = _context3.sent;

                if (!(tokens === null)) {
                  _context3.next = 18;
                  break;
                }

                return _context3.abrupt("return", null);

              case 18:
                idTokenExpired = !!((_tokens = tokens) !== null && _tokens !== void 0 && _tokens.idToken) && isTokenExpired({
                  expiresAt: ((_tokens$idToken$paylo = (_tokens$idToken = tokens.idToken) === null || _tokens$idToken === void 0 ? void 0 : (_tokens$idToken$paylo2 = _tokens$idToken.payload) === null || _tokens$idToken$paylo2 === void 0 ? void 0 : _tokens$idToken$paylo2.exp) !== null && _tokens$idToken$paylo !== void 0 ? _tokens$idToken$paylo : 0) * 1000,
                  clockDrift: (_tokens$clockDrift = tokens.clockDrift) !== null && _tokens$clockDrift !== void 0 ? _tokens$clockDrift : 0
                });
                accessTokenExpired = isTokenExpired({
                  expiresAt: ((_tokens$accessToken$p = (_tokens$accessToken = tokens.accessToken) === null || _tokens$accessToken === void 0 ? void 0 : (_tokens$accessToken$p2 = _tokens$accessToken.payload) === null || _tokens$accessToken$p2 === void 0 ? void 0 : _tokens$accessToken$p2.exp) !== null && _tokens$accessToken$p !== void 0 ? _tokens$accessToken$p : 0) * 1000,
                  clockDrift: (_tokens$clockDrift2 = tokens.clockDrift) !== null && _tokens$clockDrift2 !== void 0 ? _tokens$clockDrift2 : 0
                });

                if (!(options !== null && options !== void 0 && options.forceRefresh || idTokenExpired || accessTokenExpired)) {
                  _context3.next = 26;
                  break;
                }

                _context3.next = 23;
                return this.refreshTokens({
                  tokens: tokens,
                  username: username
                });

              case 23:
                tokens = _context3.sent;

                if (!(tokens === null)) {
                  _context3.next = 26;
                  break;
                }

                return _context3.abrupt("return", null);

              case 26:
                return _context3.abrupt("return", {
                  accessToken: (_tokens2 = tokens) === null || _tokens2 === void 0 ? void 0 : _tokens2.accessToken,
                  idToken: (_tokens3 = tokens) === null || _tokens3 === void 0 ? void 0 : _tokens3.idToken,
                  signInDetails: (_tokens4 = tokens) === null || _tokens4 === void 0 ? void 0 : _tokens4.signInDetails
                });

              case 27:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[0, 4]]);
      }));

      function getTokens(_x) {
        return _getTokens.apply(this, arguments);
      }

      return getTokens;
    }()
  }, {
    key: "refreshTokens",
    value: function () {
      var _refreshTokens = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(_ref3) {
        var tokens, username, signInDetails, newTokens;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                tokens = _ref3.tokens, username = _ref3.username;
                _context4.prev = 1;
                signInDetails = tokens.signInDetails;
                _context4.next = 5;
                return this.getTokenRefresher()({
                  tokens: tokens,
                  authConfig: this.authConfig,
                  username: username
                });

              case 5:
                newTokens = _context4.sent;
                newTokens.signInDetails = signInDetails;
                _context4.next = 9;
                return this.setTokens({
                  tokens: newTokens
                });

              case 9:
                Hub.dispatch('auth', {
                  event: 'tokenRefresh'
                }, 'Auth', AMPLIFY_SYMBOL);
                return _context4.abrupt("return", newTokens);

              case 13:
                _context4.prev = 13;
                _context4.t0 = _context4["catch"](1);
                return _context4.abrupt("return", this.handleErrors(_context4.t0));

              case 16:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[1, 13]]);
      }));

      function refreshTokens(_x2) {
        return _refreshTokens.apply(this, arguments);
      }

      return refreshTokens;
    }()
  }, {
    key: "handleErrors",
    value: function handleErrors(err) {
      assertServiceError(err);

      if (err.message !== 'Network error') {
        // TODO(v6): Check errors on client
        this.clearTokens();
      }

      Hub.dispatch('auth', {
        event: 'tokenRefresh_failure',
        data: {
          error: err
        }
      }, 'Auth', AMPLIFY_SYMBOL);

      if (err.name.startsWith('NotAuthorizedException')) {
        return null;
      }

      throw err;
    }
  }, {
    key: "setTokens",
    value: function () {
      var _setTokens = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(_ref4) {
        var tokens;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                tokens = _ref4.tokens;
                return _context5.abrupt("return", this.getTokenStore().storeTokens(tokens));

              case 2:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function setTokens(_x3) {
        return _setTokens.apply(this, arguments);
      }

      return setTokens;
    }()
  }, {
    key: "clearTokens",
    value: function () {
      var _clearTokens = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                return _context6.abrupt("return", this.getTokenStore().clearTokens());

              case 1:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function clearTokens() {
        return _clearTokens.apply(this, arguments);
      }

      return clearTokens;
    }()
  }, {
    key: "getDeviceMetadata",
    value: function getDeviceMetadata(username) {
      return this.getTokenStore().getDeviceMetadata(username);
    }
  }, {
    key: "clearDeviceMetadata",
    value: function clearDeviceMetadata(username) {
      return this.getTokenStore().clearDeviceMetadata(username);
    }
  }]);

  return TokenOrchestrator;
}();

export { TokenOrchestrator };